var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 57.375H44.625V63.75H25.5V57.375ZM25.5 70.125H57.375V76.5H25.5V70.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.875 12.75H19.125C17.4348 12.7517 15.8142 13.4239 14.6191 14.6191C13.4239 15.8142 12.7517 17.4348 12.75 19.125V82.875C12.7517 84.5652 13.4239 86.1858 14.6191 87.3809C15.8142 88.5761 17.4348 89.2483 19.125 89.25H82.875C84.5652 89.2483 86.1858 88.5761 87.3809 87.3809C88.5761 86.1858 89.2483 84.5652 89.25 82.875V19.125C89.2483 17.4348 88.5761 15.8142 87.3809 14.6191C86.1858 13.4239 84.5652 12.7517 82.875 12.75V12.75ZM57.375 19.125V31.875H44.625V19.125H57.375ZM19.125 82.875V19.125H38.25V38.25H63.75V19.125H82.875L82.8782 82.875H19.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStok);
export default __webpack_public_path__ + "static/media/stok.eff6caf5e394cd9f8375fe8bca42f32b.svg";
export { ForwardRef as ReactComponent };